var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-avatar"},[_c('ds-iconfont',{style:(_vm.style),attrs:{"icon-class":"icon-mk-wx-user"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }